function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtsign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 145,
    height: 145,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    x: -1.890625,
    y: 109.83594,
    fontSize: "144px",
    style: {
      fontSize: 144,
      fontFamily: "Arial"
    }
  }, "@"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtsign);
export default __webpack_public_path__ + "static/media/atsign.fa672e6b212e4b0899f17c31d9e4504e.svg";
export { ForwardRef as ReactComponent };